import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "catalog-search-input-filter__value-input" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = { class: "catalog-search-input-filter__value-label" };
const _hoisted_4 = { class: "catalog-search-input-filter__value-count" };
import { computed, inject } from "vue";
import ProductAttributeValueIcon from '@astina/paloma-shop-common-ui/src/components/ProductAttributeValueIcon.vue';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import portalConfig from "../services/PortalConfig";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogSearchFilterInputValue',
    props: {
        value: {},
        filter: {},
        selected: { type: Boolean }
    },
    emits: ['toggle'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const uiConfig = inject('productAttributesUiConfig', { icons: {} });
        function select() {
            if (disabled.value) {
                return;
            }
            emit('toggle', props.value);
        }
        const disabled = computed(() => {
            return props.value.count === 0;
        });
        const icon = computed(() => {
            if (!uiConfig || !props.value.valueCode) {
                return null;
            }
            const filterSettings = portalConfig.catalog.search.filters[props.filter.name];
            if (!(filterSettings?.showIcons)) {
                return null;
            }
            const filterAttribute = findFilterAttribute();
            if (!filterAttribute) {
                return null;
            }
            const attrConfig = (uiConfig.icons || {})[filterAttribute];
            if (!attrConfig) {
                return null;
            }
            return attrConfig[props.value.valueCode] || attrConfig['*'] || null;
        });
        function findFilterAttribute() {
            if (props.filter.property.indexOf('.attributes.') === -1) {
                return null;
            }
            return props.filter.property.split('.')[2];
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                onClick: _withModifiers(select, ["prevent"]),
                class: _normalizeClass(["catalog-search-input-filter__value", {
                        'catalog-search-input-filter__value--selected': __props.selected,
                        'catalog-search-input-filter__value--disabled': disabled.value
                    }])
            }, [
                _createElementVNode("label", _hoisted_1, [
                    _createElementVNode("input", {
                        type: "checkbox",
                        disabled: disabled.value,
                        class: "catalog-search-input-filter__value-checkbox"
                    }, null, 8, _hoisted_2),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createVNode(Icon, {
                        name: __props.selected ? 'check-square' : 'square',
                        "icon-style": "light",
                        class: "catalog-search-input-filter__value-icon"
                    }, null, 8, ["name"]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    (icon.value)
                        ? (_openBlock(), _createBlock(ProductAttributeValueIcon, {
                            key: 0,
                            icon: icon.value,
                            class: "catalog-search-input-filter__value-icon"
                        }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.value.value || __props.value.valueCode), 1)
                ]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.value.count), 1)
            ], 2));
        };
    }
});
